import {
    forEach,
    indexOf,
    join
} from 'lodash'; //	lodash 工具库
import {
    axios
} from '@/utils/request'; //  网络请求库
import Storage from 'store2'; //  本地存储
import Store from '@/store/index.js'; //	加载状态管理
import Router from '@/router'; //  路由管理
import {
    setDocumentTitle,
    domTitle
} from '@/utils/domUtil'; //  设置页面信息
import {
    i18nRender
} from '@/locales'; //  国际化
const localSpecialFlagKey = 'localSpecialFlag'; //	本地用户缓存特殊标识

/**
 * 工具函数库
 */
export default {

    /**
     * 获得请求头配置信息
     */
    getHttpConfig() {
        let config = {};
        config.baseURL = process.env.VUE_APP_API_DOMAIN;
        config.header = {
            'Accept': process.env.VUE_APP_API_ACCEPT,
        };
        let tokenData = Store.getters['token/getTokenData']; //	使用了vuex的命名空间
        if (tokenData.access_token) {
            config.header.Authorization = tokenData.access_token;
        }
        return config;
    },

    /**
     * 将时间字符串转换成时间戳
     * @param {String} timeStr	时间字符串。如：2021-01-26 11:11；2021/01/26 11:11；2021 01 26 11:11
     * @param {Boolean} micro	是否显示微秒。默认不显示
     */
    strToTime(timeStr = '', micro = false) {
        let date = timeStr == '' ? new Date() : new Date(timeStr);
        return micro ? date.getTime() : parseInt(date.getTime() / 1000);
    },

    /**
     * 计算填入的时间距离当前时间的时间差
     * @param {*} time 格式为yyyy-mm-dd hh:mm:ss 指定时间
     * @returns 
     */
    computTime(time) {
        let nowTime = Date.parse(new Date()); // 当前时间的时间戳
        let endTime = Date.parse(new Date(time)); // 指定时间的时间戳
        if (endTime < nowTime) {
            return false; //  截止时间已过
        } else {
            // 计算相差天数
            let timeResult = endTime - nowTime;
            let days = Math.floor(timeResult / (24 * 3600 * 1000));
            // 计算出小时数
            let dayMS = timeResult % (24 * 3600 * 1000); // 计算天数后剩余的毫秒数
            let hours = Math.floor(dayMS / (3600 * 1000));
            // 计算相差分钟数
            let hoursMS = dayMS % (3600 * 1000); // 计算小时数后剩余的毫秒数
            let minutes = Math.floor(hoursMS / (60 * 1000));
            // 计算相差秒数
            let minutesMS = hoursMS % (60 * 1000); // 计算分钟数后剩余的毫秒数
            let second = minutesMS / 1000;
            let result = days + "天 " + hours + "小时 ";
            // let result = days + "天" + hours + "小时" + minutes + "分" + second + "秒";
            return result;
        }
    },

    /**
     * 根据开始时间和结束时间来显示状态
     * @param {*} startTime 开始时间
     * @param {*} endTime 结束时间
     * @returns 
     */
    getStatusByComputTime(startTime, endTime) {
        let nowTimeStamp = Date.parse(new Date()); // 当前时间的时间戳
        let startTimeStamp = Date.parse(new Date(startTime)); // 指定开始时间的时间戳
        let endTimeStamp = Date.parse(new Date(endTime)); // 指定结束时间的时间戳
        return (startTimeStamp > nowTimeStamp) ? 1 : (endTimeStamp < nowTimeStamp) ? 3 : 2;
    },

    /**
     * 判断是否为手机号码
     */
    isPhone(phone) {
        return /^1[3456789]\d{9}$/.test(phone)
    },

    /**
     * 验证邮箱
     * @param {*} value 
     * @returns 
     */
    isEmail(value) {
        return /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(value)
    },


    /**
     * 判断内容是否为空
     * @param {Object} val
     * @returns {boolean}
     */
    isEmpty(val) {
        switch (typeof val) {
            case 'undefined':
                return true;
            case 'string':
                if (val.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length == 0) return true;
                break;
            case 'boolean':
                if (!val) return true;
                break;
            case 'number':
                if (0 === val || isNaN(val)) return true;
                break;
            case 'object':
                if (null === val || val.length === 0) return true;
                for (var i in val) {
                    return false;
                }
                return true;
        }
        return false;
    },

    /**
     * 深拷贝
     * @param {Object | Array} data 要复制的内容
     */
    deepCopy(data) {
        return JSON.parse(JSON.stringify(data))
    },

    /**
     * 将一维数据对象根据连接符转换成字符串
     * @param {Object} params 
     * @param {Object} prefix 连接符
     */
    implode(params, prefix = '&') {
        let str = '';
        forEach(params, (value, key) => {
            str += (str == '' ? '?' : prefix) + key + '=' + encodeURIComponent(value);
        });
        return str;
    },

    /**
     * 对 encodeURIComponent() 函数编码的 URI 进行解码。
     * @param {Object} str 	内容字符串
     * @param {Object} type 转换类型，json:解码后转换成JSON数据。
     */
    decodeURIComponentValue(str, type = '') {
        //	str.replace(/%/g, '%25') 解决“%”字符影响JSON解析问题
        str = str.replace(/%/g, '%25');
        let content = decodeURIComponent(str).replace(/%/g, '%25');
        return type == 'json' ? JSON.parse(content) : content;
    },

    /**
     * 人性化时间提示
     * @returns 
     */
    timeFix() {
        const time = new Date()
        const hour = time.getHours()
        return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
    },

    /**
     * 普通数字转成中文数组
     * @param {*} num 阿拉伯数字
     * @returns 
     */
    numToChineseNum(num) {
        var AA = new Array("零", "一", "二", "三", "四", "五", "六", "七", "八", "九");
        var BB = new Array("", "十", "百", "千", "万", "亿", "点", "");
        var a = ("" + num).replace(/(^0*)/g, "").split("."),
            k = 0,
            re = "";
        if (!/^\d*(\.\d*)?$/.test(num)) {
            return re;
        }
        for (var i = a[0].length - 1; i >= 0; i--) {
            switch (k) {
                case 0:
                    re = BB[7] + re;
                    break;
                case 4:
                    if (!new RegExp("0{4}\\d{" + (a[0].length - i - 1) + "}$").test(a[0]))
                        re = BB[4] + re;
                    break;
                case 8:
                    re = BB[5] + re;
                    BB[7] = BB[5];
                    k = 0;
                    break;
            }
            if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0) re = AA[0] + re;
            if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re;
            k++;
        }
        if (a.length > 1) //加上小数部分(如果有小数部分)
        {
            re += BB[6];
            for (var i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)];
        }
        return re;
    },

    /**
     * 判断是否是IE浏览器
     * @returns 
     */
    isIE() {
        const bw = window.navigator.userAgent
        const compare = (s) => bw.indexOf(s) >= 0
        const ie11 = (() => 'ActiveXObject' in window)()
        return compare('MSIE') || ie11
    },

    /**
     * 判读是否是手机
     * @returns 
     */
    isMobile() {
        const userAgent = window.navigator.userAgent;  
        const isMobile = /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile/.test(userAgent);
        return isMobile;
    },

    /**
     * 计算密码强度分数（分数得分 0-100）
     * @param {*} pass 
     * @returns 
     */
    scorePassword(pass) {
        let score = 0
        if (!pass) {
            return score
        }
        // 验证每个字母不能重复5次
        const letters = {}
        for (let i = 0; i < pass.length; i++) {
            letters[pass[i]] = (letters[pass[i]] || 0) + 1
            score += 5.0 / letters[pass[i]]
        }

        // 验证是否存在数字，大小写字母
        const variations = {
            digits: /\d/.test(pass),
            lower: /[a-z]/.test(pass),
            upper: /[A-Z]/.test(pass),
            nonWords: /\W/.test(pass)
        }

        let variationCount = 0
        for (var check in variations) {
            variationCount += (variations[check] === true) ? 1 : 0
        }
        score += (variationCount - 1) * 10
        return parseInt(score)
    },

    /**
     * 返回上一页或者跳转到首页
     * @param {Object} time 等待时间
     */
    navigateBackOrIndex(time = 800) {
        setTimeout(() => {
            Router.back();
        }, time);
    },

    /**
     * 界面跳转URL
     * @param {Object} data	跳转的数据
     *                      {
     *                          url:'',
     *                          page_type:'',
     *                          page_params:'',
     *                      }
     * @param {Object} blank	界面打开形式。self：当前页面打开、blank：新窗口打开、back：返回上一层
     */
    navigationUrl(data, blank = 'blank') {
        if (data.url == '') {
            return false;
        }
        if (data.page_type == 'navigation_page') {

        } else {
            let postData = {};
            if (data.page_params) {
                postData = data.page_params;
            }
            if (blank == 'blank') {
                //  验证URL是否是http地址
                if (indexOf(data.url, 'http')) {
                    let query = this.implode(postData);
                    let url = data.url;
                    if (!this.isEmpty(query)) {
                        url += query;
                    }
                    window.open(url, '_blank');
                } else {
                    let route = Router.resolve({
                        path: data.url,
                        query: postData
                    });
                    window.open(route.href, '_blank');
                }
            } else if (blank == 'self') {
                if (indexOf(data.url, 'http')) {
                    let query = this.implode(postData);
                    let url = data.url;
                    if (!this.isEmpty(query)) {
                        url += query;
                    }
                    window.location.href = url;
                } else {
                    Router.push({
                        path: data.url,
                        query: postData
                    });
                }
            } else {
                Router.back();
            }
        }
    },

    /**
     * 设置页面标题
     * @param {*} content 标题内容
     */
    setDocumentTitle(content) {
        setDocumentTitle(`${i18nRender(content)} - ${domTitle}`);
    },

    /**
     * 跳转到商品详情页
     * @param {*} goodsId 商品ID
     */
    gotoGoodsDetail(goodsId, blank = '_blank') {
        if (blank == 'self') {
            Router.push({
                path: '/goods/detail',
                query: {
                    id: goodsId
                }
            });
        } else {

            let route = Router.resolve({
                path: '/goods/detail',
                query: {
                    id: goodsId
                }
            });
            window.open(route.href, '_blank');
        }
    },

    /**
     * 获得访问者
     * @param {*} option 
     */
    visitor(option) {
        let defaults = {
            special_flag: ''
        };
        let options = Object.assign(defaults, option || {});
        const localSpecialFlagData = Storage.get(localSpecialFlagKey);
        if (localSpecialFlagData) {
            options.special_flag = localSpecialFlagData;
            Storage.remove(localSpecialFlagKey)
        }
        axios.post('/public/visitor', options).then(res => {}).catch(err => {});
    },

    /**
     * 设置特殊标识
     * @param {*} data 
     * @returns 
     */
    setLocalSpecialFlagStorage(data) {
        return Storage.set(localSpecialFlagKey, data);
    },
};